import { PermissionDomain, PermissionResource } from '../model/types';

export const PERMISSION_RESOURCE_TO_DOMAIN_MAP: Record<
  PermissionResource,
  PermissionDomain
> = {
  [PermissionResource.TenantUsers]: PermissionDomain.Users,
  [PermissionResource.ClientUsers]: PermissionDomain.Users,
  [PermissionResource.TenantRoles]: PermissionDomain.Roles,
  [PermissionResource.ClientRoles]: PermissionDomain.Roles,
  [PermissionResource.TenantPermissions]: PermissionDomain.Permissions,
  [PermissionResource.TenantClients]: PermissionDomain.Clients,
  [PermissionResource.ClientContracts]: PermissionDomain.Contracts,
  [PermissionResource.TenantContracts]: PermissionDomain.Contracts,
  [PermissionResource.ClientCards]: PermissionDomain.Cards,
  [PermissionResource.TenantCards]: PermissionDomain.Cards,
  [PermissionResource.ClientPin]: PermissionDomain.Pin,
  [PermissionResource.ClientLimits]: PermissionDomain.Limits,
  [PermissionResource.TenantLimits]: PermissionDomain.Limits,
  [PermissionResource.ClientLimitTemplates]: PermissionDomain.LimitTemplates,
  [PermissionResource.TenantSystemLimitTemplates]: PermissionDomain.SystemLimitTemplates,
  [PermissionResource.ClientSystemLimitTemplates]: PermissionDomain.SystemLimitTemplates,
  [PermissionResource.TenantPrices]: PermissionDomain.Prices,
  [PermissionResource.ClientDiscounts]: PermissionDomain.Discounts,
  [PermissionResource.TenantDiscounts]: PermissionDomain.Discounts,
  [PermissionResource.TenantMaxDiscounts]: PermissionDomain.MaxDiscounts,
  [PermissionResource.TenantDiscountMatrices]: PermissionDomain.DiscountMatrices,
  [PermissionResource.TenantDiscountApprovals]: PermissionDomain.Discounts,
  [PermissionResource.TenantOverdrafts]: PermissionDomain.Overdrafts,
  [PermissionResource.TenantOverdraftSummaries]: PermissionDomain.Overdrafts,
  [PermissionResource.TenantRegionalManagerOverdraftLimits]: PermissionDomain.Overdrafts,
  [PermissionResource.ClientBalances]: PermissionDomain.Balances,
  [PermissionResource.ClientFuelOrders]: PermissionDomain.FuelOrders,
  [PermissionResource.ClientFuelOrderCoupons]: PermissionDomain.FuelOrderCoupons,
  [PermissionResource.TenantFuelOrderCoupons]: PermissionDomain.FuelOrderCoupons,
  [PermissionResource.ClientCoupons]: PermissionDomain.Coupons,
  [PermissionResource.TenantCoupons]: PermissionDomain.Coupons,
  [PermissionResource.TenantCouponRefundRequests]: PermissionDomain.CouponRefundRequests,
  [PermissionResource.ClientProducts]: PermissionDomain.Products,
  [PermissionResource.ClientProductGroups]: PermissionDomain.ProductGroups,
  [PermissionResource.ClientTransactions]: PermissionDomain.Transactions,
  [PermissionResource.TenantTransactions]: PermissionDomain.Transactions,
  [PermissionResource.ClientDrivers]: PermissionDomain.Drivers,
  [PermissionResource.TenantDrivers]: PermissionDomain.Drivers,
  [PermissionResource.MachineOrders]: PermissionDomain.Orders,
  [PermissionResource.MachineImportJobs]: PermissionDomain.ImportJobs,
  [PermissionResource.MachineEvents]: PermissionDomain.Events,
  [PermissionResource.MachinePos]: PermissionDomain.Pos,
};
